import { render, staticRenderFns } from "./PreMatchBoard.vue?vue&type=template&id=40bc6f28&scoped=true"
import script from "./PreMatchBoard.vue?vue&type=script&lang=js"
export * from "./PreMatchBoard.vue?vue&type=script&lang=js"
import style0 from "./PreMatchBoard.vue?vue&type=style&index=0&id=40bc6f28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bc6f28",
  null
  
)

export default component.exports